import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/es5/util/colors'

Vue.use(Vuetify,);


export default new Vuetify({
    theme: {
        options: {
          customProperties: true,
        },
        light: true,
        themes: {
          /* light:  {
            primary: colors.indigo.base,
            dark_primary: colors.indigo.darken2,
            light_primary: colors.indigo.lighten4,
            secondary: colors.orange.darken2,
            primary_text: colors.grey.darken4,
            secondary_text: colors.grey.darken1,
            accent: colors.orange.base,
            divider: colors.grey.lighten1,
            error: colors.red.base,
            warning: colors.amber.base,
            info: colors.blueGrey.base,
            success: colors.green.base
            }, */
            /* light:  {
              primary: colors.indigo.base,
              dark_primary: colors.indigo.darken2,
              light_primary: colors.indigo.lighten4,
              secondary: colors.orange.darken2,
              primary_text: colors.grey.darken4,
              secondary_text: colors.grey.darken1,
              accent: colors.orange.base,
              divider: colors.grey.lighten1,
              error: colors.red.base,
              warning: colors.amber.base,
              info: colors.blueGrey.base,
              success: colors.green.base
              } */
           light:  {
            primary: colors.blue.base,
            dark_primary: colors.blue.darken2,
            light_primary: colors.blue.lighten4,
            primary_text: colors.grey.darken4,
            secondary_text: colors.grey.darken1,
            accent: colors.yellow.base,
            divider: colors.grey.lighten1,
            error: colors.red.base,
            warning: colors.amber.base,
            info: colors.blueGrey.base,
            success: colors.green.base
           },
           /*light:  {
            primary: colors.cyan.base,
            dark_primary: colors.cyan.darken2,
            light_primary: colors.cyan.lighten4,
            secondary: colors.yellow.darken2,
            primary_text: colors.grey.darken4,
            secondary_text: colors.grey.darken1,
            accent: colors.yellow.base,
            divider: colors.grey.lighten1,
            error: colors.red.base,
            warning: colors.amber.base,
            info: colors.blueGrey.base,
            success: colors.green.base
            }, */
        },
      },
});
